import axios from "axios";
import {ref} from "vue";
import {useApiStore} from "@/stores/ApiStore";
import moment from "moment/moment";
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

let startDate = ref('');
let endDate = ref('');
let compare = ref('');

export default class ApiService {
    constructor() {
    }
    updateDateRange(start, end, period)
    {
        startDate.value = moment(start).format("YYYY-MM-DD");
        endDate.value = moment(end).format("YYYY-MM-DD");
        compare.value = period;
    }

    async getMetaData() {
        let apiDataStore = useApiStore()
        axios.defaults.headers.common["apikey"] = apiDataStore.getApiKey
        return await axios.get(`/cms/dashboard/metadata`,{
            params:{
                'lang': apiDataStore.getLang
            }
        })
            .then(function (response) {
                return response.data
            }).catch(error => {
                console.log(error)
            });
    }

    async getWidgets() {
        let apiDataStore = useApiStore()
        return await axios.get(`/cms/dashboard/widgets`,{
            params:{
                'lang': apiDataStore.getLang
            }
        } )
            .then(function (response) {
                return response.data
            }).catch(error => {
                console.log(error)
            });
    }
    async getWidget(handle) {
        let apiDataStore = useApiStore()
        return await axios.get(`/cms/dashboard/widget/` + handle,{
            params:{
                'lang': apiDataStore.getLang
            }
        })
            .then(function (response) {
                return response.data
            }).catch(error => {
                console.log(error)
            });
    }

    async getWarnings() {
        let apiDataStore = useApiStore()
        axios.defaults.headers.common["apikey"] = apiDataStore.getApiKey
        return await axios.get('/stats/shop/warnings', {
            params:{
                'lang': apiDataStore.getLang
            }
        })
            .then(function (response) {
                return response.data
            }).catch(error => {
                console.log(error)
            })
    }

    async get(endpoint) {
        let apiDataStore = useApiStore()
        return await axios.get(endpoint, {
            params:{
                'startDate' : startDate.value,
                'endDate' : endDate.value,
                'compareTo' : compare.value,
                'lang': apiDataStore.getLang
            }
        })
            .then(function (response) {
                return response.data
            }).catch(error => {
                console.log(error)
            });
    }

    async getSearchterms(endpoint) {
        return await axios.get(endpoint, {
            params:{
                'startDate' : startDate.value,
                'endDate' : endDate.value,
                'compareTo' : compare.value
            }
        })
            .then(function (response) {
                return response.data
            }).catch(error => {
                console.log(error)
            });
    }

    async postData(endpoint, data) {
        let apiDataStore = useApiStore()
        return await axios.post(endpoint, data ,{
            params:{
                'lang': apiDataStore.getLang
            }
        })
            .then(function (response) {
                return(response);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    async getErpConnectionStatus() {
        let apiDataStore = useApiStore()
        axios.defaults.headers.common["apikey"] = apiDataStore.getApiKey
        return await axios.get('/stats/shop/sync-connection')
            .then(function (response) {
                return response.data
            }).catch(error => {
                console.log(error)
            })
    }

    async getPageviews(url = null, userId = null, minPageviews = null, maxPageviews = null) {
        let apiDataStore = useApiStore()
        axios.defaults.headers.common["apikey"] = apiDataStore.getApiKey
        return await axios.get('/stats/pageviews', {
            params:{
                'startDate' : startDate.value,
                'endDate' : endDate.value,
                'url': url,
                'userId': userId,
                'minPageviews': minPageviews,
                'maxPageviews': maxPageviews,
                'lang': apiDataStore.getLang
            }
        })
            .then(function (response) {
                return response.data
            }).catch(error => {
                console.log(error)
            })
    }

    async getPageVisitDetails(url = null, userId = null, page = 0, pageSize = 20) {
        let apiDataStore = useApiStore()
        axios.defaults.headers.common["apikey"] = apiDataStore.getApiKey
        return await axios.get('/stats/page-visit-details', {
            params:{
                'startDate' : startDate.value,
                'endDate' : endDate.value,
                'url': url,
                'userId': userId,
                'page': page,
                'pageSize': pageSize,
                'lang': apiDataStore.getLang
            }
        })
            .then(function (response) {
                return response.data
            }).catch(error => {
                console.log(error)
            })
    }
}
